export const getThumbnail = (data) => {
    const image = data.thumbnails.image && data.thumbnails.image[0] && data.thumbnails.image[0].url;

    return image || '';
};
